import axios from 'axios';

// 超时将定义为失败
axios.defaults.timeout = 500000;
axios.defaults.withCredentials = true;
// 定义一个请求拦截器

axios.interceptors.request.use(
    config => {
        // console.log(config.url) 
        // config.url = `http://192.168.101.94:8080${config.url}`
        config.url = `https://yagetech.com/web${config.url}`
        // /ypf1ng/fu924cfc0u75w0wr?singleDoc#SPgpO
        config.headers = { "Content-Type": "application/json" } 
        // 携带令牌
        // const authentication = localStorage.getItem('authentication');
        // authentication && (config.headers.authentication = authentication);
        return config;
    },
    error => {
        return Promise.reject(error)
    }
);

// 响应拦截器
axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        return Promise.reject(error)
    }
)

// 封装两个请求
export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        })
            .then(response => {
                resolve(response);
            })
            .catch(err => {
                reject(err)
            })
    })
}
export function post(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, data)
            .then(response => {
                resolve(response);
            })
            .catch(err => {
                reject(err)
            })
    })
}